import { APP_RESET } from '@/actions/types';

export const resetApp = () => {
  return {
    type: APP_RESET
  }
};
